import { LanguageSchema } from "@/assets/lang";

const el: LanguageSchema = {
  "title": "Χταπόδι",
  "button": {
    "cancel": "Ακύρωση",
    "ok": "OK",
    "discardChanges": "Απόρριψη αλλαγών",
    "search": "Αναζήτηση",
    "confirm": "Επιβεβαίωση",
    "choose": "Επιλέξτε",
    "forward": "Επόμενο",
    "back": "Πίσω",
    "reset": "Πίσω",
    "apply": "Εφαρμογή",
    "login": "Είσοδος",
    "logout": "Αποσύνδεση",
    "send": "Υποβολή",
    "backToStart": "Πίσω στην αρχή",
    "backToLogin": "Επιστροφή στην είσοδο",
    "no": "Όχι",
    "yes": "Ναι",
    "toPayment": "Για πληρωμή",
    "finishOrder": "Τοποθετήστε την παραγγελία",
    "thank": "Σας ευχαριστούμε",
    "sendInvite": "Αποστολή πρόσκλησης",
    "resend": "Επαναποστολή",
    "startNow": "Ξεκινήστε τώρα",
    "skip": "Skip",
    "register": "Εγγραφείτε τώρα",
    "registerNoCode": "Εγγραφή χωρίς κωδικό",
    "save": "Αποθήκευση",
    "saveChanges": "Εφαρμόστε τις αλλαγές",
    "delete": "{target} delete",
    "addCart": "Προσθήκη λίστας στο καλάθι αγορών",
    "orderNow": "Παραγγείλετε τώρα",
    "add": "Προσθήκη στο",
    "changePassword": "Αλλαγή κωδικού πρόσβασης",
    "changeLogin": "Αλλαγή στοιχείων σύνδεσης",
    "changeEmail": "Αλλαγή email",
    "edit": "Επεξεργασία",
    "share": "Μοιραστείτε το",
    "delivererNotFound": "Ο προμηθευτής δεν βρέθηκε?",
    "joinLocation": "Γίνετε μέλος της ομάδας",
    "createLocation": "Δημιουργία τοποθεσίας",
    "editSupplier": "Προμηθευτής @.lower:button.edit",
    "create": "Δημιουργία",
    "deleteSupplier": "Διαγραφή προμηθευτή",
    "forwardApp": "Μετάβαση στην εφαρμογή",
    "endIntro": "Ολοκλήρωση εισαγωγής",
    "upload": "Ανέβασμα",
    "showMore": "δείξτε περισσότερα",
    "hide": "απόκρυψη",
    "deleteAll": "Διαγραφή όλων",
    "settings": "Ρυθμίσεις",
    "manualSort": "Επεξεργασία χειροκίνητης ταξινόμησης",
    "switchOldVersion": "Στην παλιά έκδοση",
    "goToAppVersion": "Χρήση του Octopus στο πρόγραμμα περιήγησης",
    "updateList": "Προσθήκη στη λίστα",
    "updateCart": "Προσθήκη στο καλάθι",
    "openCameraScanner": "Σαρωτής ανοικτής κάμερας",
    "orderOverview": "Στην επισκόπηση της παραγγελίας",
    "deleteSupplierCart": "Διαγραφή καλαθιού αγορών",
    "resetAmount": "Επαναφορά ποσοτήτων προϊόντων",
    "requestAiCall": "Αίτημα κλήσης AI",
    "filter": {
      "all": "Τα πάντα",
      "promotion": "Actions",
      "productSuggestion": "Inspirations"
    }
  },
  "input": {
    "text": "Κείμενο",
    "password": "Κωδικός πρόσβασης | Κωδικοί πρόσβασης",
    "email": "Ηλεκτρονικό ταχυδρομείο",
    "number": "Αριθμός",
    "url": "Σύνδεσμος",
    "tel": "Τηλέφωνο",
    "search": "Αναζήτηση",
    "date": "Ημερομηνία",
    "orderDate": "Ημερομηνία παραγγελίας",
    "datetime": "Ημερομηνία",
    "datetime-local": "Ώρα τοπική ώρα",
    "month": "Μήνας",
    "week": "Εβδομάδα",
    "time": "Ώρα",
    "range": "Κλίμακα",
    "color": "Χρώμα"
  },
  "table": {
    "empty": "Ο πίνακας δεν επιλέγει στοιχεία"
  },
  "label": {
    "confirm": "επιβεβαιώστε",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Προσθήκη νέου συναγερμού παραγγελίας",
    "selectPlaceholder": "Παρακαλώ επιλέξτε",
    "orderHint": "Σημείωση από τον προμηθευτή",
    "selectTitle": "Επιλέξτε",
    "date": "@:input.date",
    "time": "Ώρα",
    "dateTime": "@:label.date και @:label.time",
    "sum": "Σύνολο",
    "orderDetails": "Λεπτομέρειες τιμολογίου",
    "promoCode": "Κωδικός κουπονιού",
    "orderNumber": "Αριθμός παραγγελίας",
    "octopusId": "Αναγνωριστικό χταποδιού",
    "orderMessage": "Μήνυμα παραγγελίας",
    "description": "Περιγραφή",
    "sort": "Ταξινόμηση",
    "priceRange": "Εύρος τιμών",
    "login": "Παρακαλώ συνδεθείτε",
    "user": "Χρήστης",
    "newEmail": "Νέο email",
    "oldPassword": "Παλιό @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password forgotten",
    "contactData": "Στοιχεία επικοινωνίας",
    "name": "Όνομα",
    "list": "Κατάλογος",
    "type": "Τύπος",
    "zip": "POSTCODE",
    "city": "Πόλη",
    "street": "Διεύθυνση",
    "streetNumber": "Αριθμός κατοικίας",
    "phone": "Τηλέφωνο",
    "fax": "Φαξ",
    "streetName": "Όνομα οδού",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Αριθμός πελάτη/αριθμός τόπου αγοράς",
    "quickstart": "Κωδικός γρήγορης εκκίνησης",
    "email": "@:input.email",
    "firstName": "Ονοματεπώνυμο",
    "lastName": "Όνομα",
    "dark": "Dark",
    "light": "Light",
    "standard": "Ρύθμιση συστήματος",
    "amount": "Ποσότητα",
    "multipleAmount": "Η ποσότητα πρέπει να είναι πολλαπλάσιο του {στόχου}",
    "maxAmount": "Μέγιστο {target} στοιχείο",
    "standardList": "Τυπικός κατάλογος",
    "language": "Γλώσσα",
    "aiCallLanguage": "Γλώσσα κλήσης",
    "oldMessages": "Παλαιότερα νέα",
    "notification": {
      "allow": "Επιτρέψτε μηνύματα"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:object.promotion",
      "message": "@:object.message",
      "news": "Νέα",
      "reminder": "Υπενθύμιση παραγγελιών",
      "productPromotion": "Προτάσεις προϊόντων",
      "sub": {
        "newOrder": "Νέες παραγγελίες",
        "updateStatus": "Ενημέρωση παραγγελιών",
        "added": "Νέα προώθηση",
        "ending": "Προώθηση στο",
        "general": "Γενικά"
      },
      "mode": {
        "push": "Μήνυμα ώθησης",
        "email": "Ειδοποίηση μέσω ηλεκτρονικού ταχυδρομείου",
        "popup": "Αναδυόμενο παράθυρο"
      }
    },
    "teamRole": {
      "admin": "Διαχειριστής",
      "user": "Μέλος της ομάδας Pro",
      "device": "Μέλος της ομάδας base",
      "OWNER": "Ιδιοκτήτης"
    },
    "teamRoleShort": {
      "admin": "Διαχειριστής",
      "user": "Pro",
      "device": "Βάση",
      "OWNER": "Ιδιοκτήτης"
    },
    "support": {
      "general": "Υποστήριξη Octopus",
      "gastro": "Ομάδα εξυπηρέτησης πελατών Gastro",
      "technical": "Ομάδα Τεχνικής Εξυπηρέτησης Πελατών",
      "technicalLead": "Τεχνικός ηγέτης",
      "distribution": "Εξουσιοδοτημένος υπογράφων, μάρκετινγκ, πωλήσεις",
      "service": "Ομάδα εξυπηρέτησης πελατών"
    },
    "loading": {
      "location": "Φόρτωση @:object.location"
    },
    "onAccount": "Τιμολόγιο",
    "onAccountOrCash": "Τιμολόγιο ή μετρητά",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "Δεν έχει καθοριστεί",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Μπαρ / παμπ",
    "office": "Γραφείο",
    "coffeeShop": "Καφέ / Μπιστρό",
    "caterer": "Εστίαση / καντίνα / κλαμπ",
    "club": "Λέσχη / ντισκοτέκ",
    "EVENT": "Εκδήλωση",
    "DEALER": "Merchant",
    "takeAway": "Σνακ μπαρ / Περίπτερο / Take-Away",
    "canteen": "Κυλικείο",
    "restaurant": "Εστιατόριο",
    "hotel": "Ξενοδοχείο",
    "spaetshop": "Βενζινάδικο / νυχτερινό κατάστημα",
    "getraenkehaendler": "Λιανοπωλητής ποτών",
    "getraenkeabholmarkt": "Αγορά συλλογής ποτών",
    "STAR_GASTRONOMY": "Star gastronomy",
    "SYSTEM_GASTRONOMY": "System catering",
    "spaetShop": "Late shop",
    "impress": "Αποτύπωμα",
    "termsOfUse": "Όροι χρήσης",
    "agreeAGB1": "Συμφωνώ με την",
    "agreeAGB2": "Πολιτική απορρήτου",
    "agreeAGB3": "στο",
    "category": "Κατηγορία",
    "noCategory": "Χωρίς κατηγορία",
    "editTags": "Δημιουργία δικών σας κατηγοριών",
    "selectDeliverer": "Επιλέξτε @:object.deliverer",
    "threeChars": "Εισάγετε τουλάχιστον τρεις χαρακτήρες για να λάβετε αποτελέσματα αναζήτησης",
    "offlineMode": "Λειτουργία εκτός σύνδεσης",
    "disable": "απενεργοποίηση",
    "enable": "activate",
    "at": "στο",
    "atTime": "στο",
    "and": "και",
    "customerNo": "Αριθμός πελάτη",
    "current": "Τρέχον",
    "tags": "Κατηγορίες φίλτρων",
    "ownCategories": "Δικές σας κατηγορίες",
    "supplierCategories": "Κατηγορίες προμηθευτών",
    "noFilter": "Δεν υπάρχει φίλτρο",
    "quantity": "Ποσότητα",
    "quantityBiggerZero": "Με ποσότητα",
    "or": "ή",
    "delivererType": {
      "online": "Σε απευθείας σύνδεση",
      "offline": "Εκτός σύνδεσης"
    },
    "deleted": "Διαγραμμένο",
    "resetAmount": "Επαναφορά ποσότητας προϊόντος μετά την παραγγελία",
    "compatibilityMode": "Λειτουργία συμβατότητας",
    "timeIssueDelivery": "Η ημερομηνία παράδοσης που καθορίσατε είναι στο παρελθόν. Παρακαλώ επιλέξτε μια μεταγενέστερη ημερομηνία.",
    "timeIssuePickup": "Η ώρα παραλαβής που δηλώσατε είναι στο παρελθόν. Παρακαλούμε επιλέξτε μια μεταγενέστερη ημερομηνία.",
    "wait": "Παρακαλώ περιμένετε",
    "day": "Ετικέτα",
    "month": "Μήνας",
    "all": "Όλα",
    "articleNo": "Αρ.",
    "targetStock": "Ποσότητα στόχου",
    "targetStockShort": "Στόχος",
    "resetProductQuantity": "Ενεργοποιώντας το ρυθμιστικό, η ποσότητα του προϊόντος μηδενίζεται μετά την επιτυχή αποστολή της παραγγελίας σας. Εάν δεν το ενεργοποιήσετε, η ποσότητα προϊόντος παραμένει προσυμπληρωμένη για την επόμενη επεξεργασία της λίστας σας.",
    "offlineMode1": "Η λειτουργία offline σας δίνει τη δυνατότητα να συγχρονίσετε τη λίστα σας και να τη διαχειριστείτε χωρίς σύνδεση στο διαδίκτυο.",
    "offlineMode2": "Όταν βγαίνετε από τη λειτουργία εκτός σύνδεσης, όλες οι αλλαγές συγχρονίζονται με τον διακομιστή.",
    "darkMode": "Σκοτεινή λειτουργία",
    "compatibilityText": {
      "activate": "Ενεργοποιήστε αυτή τη λειτουργία εάν θέλετε να επεξεργαστείτε τις ποσότητες των προϊόντων στη λίστα σας στην εφαρμογή, αλλά να κάνετε την παραγγελία μέσω της διαδικτυακής πύλης.",
      "webPortal": "Όσο είναι ενεργοποιημένη αυτή η λειτουργία, η ποσότητα της λίστας συγχρονίζεται με τη διαδικτυακή πύλη και δεν είναι δυνατή η παραγγελία αυτής της λίστας μέσω της εφαρμογής.",
      "deactivate": "Απενεργοποιήστε αυτή τη λειτουργία αν θέλετε να κάνετε παραγγελία μέσω της εφαρμογής."
    },
    "newProductSuggestion": "Πρόταση νέου προϊόντος",
    "files": "Αρχεία",
    "issue": "Πρόβλημα",
    "place": "Τοποθεσία",
    "expectation": "Προσδοκία",
    "steps": "Βήματα",
    "availability": "Διαθεσιμότητα",
    "availableFrom": "Διαθέσιμο στο",
    "deletedLocations": "Διαγραμμένες τοποθεσίες",
    "reducedListDesign": "Σχεδιασμός μειωμένου καταλόγου",
    "reducedListDesignDescription": "Ο μειωμένος σχεδιασμός λίστας αλλάζει την προβολή της λίστας σας. Οι εικόνες των προϊόντων αποκρύπτονται, αλλά εμφανίζονται πρόσθετα κουμπιά για τη λειτουργία.",
    "insert": "εισαγωγή",
    "camera": "Σαρωτής κάμερας",
    "scanner": "Σαρωτής",
    "picture": {
      "takePicture": "Βγάλτε μια φωτογραφία",
      "selectPicture": "Επιλέξτε φωτογραφία",
      "editPicture": "Επεξεργασία εικόνας",
      "removePicture": "Αφαίρεση εικόνας"
    },
    "uncategorized": "Uncategorized",
    "orderDataLoading": "Τα δεδομένα της παραγγελίας φορτώνονται.",
    "screenshot": "Στιγμιότυπο",
    "uploadImage": "Ανέβασμα εικόνας",
    "aiCallbackPhone": "Αποθήκευση αριθμού τηλεφώνου για επανάκληση"
  },
  "error": {
    "addReminder": "Ο συναγερμός παραγγελίας δεν μπόρεσε να εκχωρηθεί σε κατάλογο",
    "noMatch": "Ο {target} δεν ταιριάζει",
    "notFound": "Ο {target} δεν βρέθηκε. | {target} δεν βρέθηκαν.",
    "invalid": "Ο {target} δεν είναι σωστός. | {target} are not correct.",
    "empty": "{target} is empty. | {target} are empty.",
    "noAuth": "{target} δεν έχει δικαιώματα. | {target} do not have permission.",
    "noAdmin": "Δεν βρέθηκε άδεια διαχειριστή.",
    "addCart": "Το προϊόν δεν μπόρεσε να προστεθεί στο καλάθι αγορών. | Το προϊόν δεν μπόρεσε να προστεθεί στο καλάθι αγορών.",
    "addPromoPackage": "Το διαφημιστικό πακέτο δεν προστέθηκε στο καλάθι αγορών ή προστέθηκε μόνο εν μέρει.",
    "addList": "Το προϊόν δεν μπόρεσε να προστεθεί στη λίστα. | Τα προϊόντα δεν μπόρεσαν να προστεθούν στη λίστα.",
    "create": "{target} could not be created. | {target} could not be created.",
    "order": "Η παραγγελία δεν μπόρεσε να επεξεργαστεί.",
    "save": "Ο {target} δεν μπόρεσε να αποθηκευτεί.",
    "delete": "Ο {target} δεν μπόρεσε να διαγραφεί.",
    "deleteUser": "Ο χρήστης δεν μπόρεσε να διαγραφεί.",
    "resendMail": "Το email δεν μπόρεσε να αποσταλεί εκ νέου.",
    "sendLink": "Δεν κατέστη δυνατή η αποστολή συνδέσμου.",
    "removeProduct": "Το προϊόν δεν μπόρεσε να αφαιρεθεί από το καλάθι αγορών. | Το προϊόν δεν μπόρεσε να αφαιρεθεί από το καλάθι αγορών.",
    "registerFalse": "Η εγγραφή απέτυχε.",
    "loginFalse": "Η σύνδεση απέτυχε.",
    "locationFalse": "Η δημιουργία τοποθεσίας απέτυχε.",
    "orderFinish": "Η παραγγελία δεν μπόρεσε να δημιουργηθεί.",
    "send": "Δεν κατέστη δυνατή η αποστολή του {στόχου}.",
    "loadSupplier": "Δεν κατέστη δυνατή η φόρτωση του προμηθευτή | Δεν κατέστη δυνατή η φόρτωση των προμηθευτών.",
    "loadLists": "Οι λίστες δεν μπόρεσαν να φορτωθούν.",
    "load": "Δεν κατέστη δυνατή η φόρτωση του {target}. | {target} could not be loaded.",
    "sendTicket": "Η ανατροφοδότηση δεν μπόρεσε να σταλεί.",
    "scanBarcode": "Ο σαρωμένος γραμμωτός κώδικας είναι άκυρος.",
    "promotionLimitReached": "Max. Ποσότητα δράσης που επιτεύχθηκε",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "Τα υποχρεωτικά πεδία δεν έχουν συμπληρωθεί",
      "format": "Η εισαγωγή δεν ήταν σωστή: Η εισαγωγή πρέπει να έχει τη μορφή {formatInfo}.",
      "formatInfo": {
        "date": "Ημερομηνία",
        "time": "Ώρα",
        "email": "Ηλεκτρονικό ταχυδρομείο",
        "date-time": "Ημερομηνία & ώρα"
      },
      "oneOf": "Η είσοδος δεν ταιριάζει με καμία από τις πιθανές τιμές",
      "minimum": "Η είσοδος υπολείπεται της ελάχιστης τιμής {min}",
      "maximum": "Η είσοδος υπερβαίνει τη μέγιστη τιμή {max}",
      "enum": "Η είσοδος δεν περιέχει μία από τις πιθανές τιμές"
    },
    "returnType": {
      "Unknown": "Παρουσιάστηκε σφάλμα",
      "BadRequest": "Το αίτημα περιέχει εσφαλμένα δεδομένα",
      "NotFound": "Η αίτηση δεν βρήκε κάποιο στοιχείο.",
      "Unauthorized": "Λείπει η εξουσιοδότηση",
      "Forbidden": "Η αίτηση δεν επιτρέπεται",
      "NotImplemented": "Το αίτημα δεν έχει υλοποιηθεί",
      "InvalidLogin": "Μη έγκυρη σύνδεση",
      "InvalidSession": "Μη έγκυρη σύνοδος",
      "InvalidPassword": "Μη έγκυρος κωδικός πρόσβασης",
      "UserNotFound": "Ο χρήστης δεν βρέθηκε",
      "UserAlreadyExists": "Ο χρήστης υπάρχει ήδη",
      "UserEmailAlreadyExists": "Ένας χρήστης με αυτό το email υπάρχει ήδη",
      "LocationNotFound": "Η τοποθεσία δεν βρέθηκε",
      "CartItemNotFound": "Το προϊόν δεν βρέθηκε",
      "ItemAlreadyInCart": "Το προϊόν βρίσκεται ήδη στο καλάθι αγορών, επεξεργαστείτε την επιλογή σας στο καλάθι αγορών",
      "ListAlreadyInCart": "Η λίστα είναι ήδη στο καλάθι αγορών, επεξεργαστείτε την επιλογή σας στο καλάθι αγορών. Η λίστα μπορεί να επεξεργαστεί μόνο όταν η λίστα έχει παραγγελθεί στο καλάθι αγορών.",
      "ListCantBeDeleted": "Η λίστα δεν μπορεί να διαγραφεί.",
      "ListEmpty": "Η λίστα είναι άδεια. Ελέγξτε αν τουλάχιστον ένα προϊόν έχει ποσότητα μεγαλύτερη από 0.",
      "SupplierNotFound": "Ο προμηθευτής δεν βρέθηκε",
      "SupplierItemNotFound": "Το προϊόν του προμηθευτή δεν βρέθηκε",
      "OrderNotFound": "Η παραγγελία δεν βρέθηκε",
      "ListNotFound": "Λίστα δεν βρέθηκε",
      "ListItemNotFound": "Δεν βρέθηκε το προϊόν της λίστας",
      "ItemAlreadyInList": "Το προϊόν βρίσκεται ήδη στη λίστα, επεξεργαστείτε την επιλογή σας στη λίστα",
      "ItemNotFromListSupplier": "Το προϊόν δεν είναι από τον προμηθευτή αυτής της λίστας",
      "NotificationNotFound": "Η κοινοποίηση δεν βρέθηκε",
      "TagNotFound": "Η κατηγορία δεν βρέθηκε",
      "TagAlreadyExists": "Η κατηγορία υπάρχει ήδη",
      "UserNotInTeam": "Αυτός ο χρήστης δεν ανήκει στην ομάδα",
      "TokenInvalid": "Ο κωδικός που έχει εισαχθεί είναι άκυρος",
      "ReminderNotFound": "Η υπενθύμιση της παραγγελίας δεν βρέθηκε",
      "OwnerCantBeEdited": "Ο ιδιοκτήτης δεν έχει δικαίωμα επεξεργασίας",
      "PromoCodeInvalid": "Ο κωδικός κουπονιού δεν είναι έγκυρος",
      "PromoCodeInvalidAlreadyExists": "Ο κωδικός κουπονιού έχει ήδη χρησιμοποιηθεί",
      "QuickStartCodeInvalid": "Ο κωδικός γρήγορης εκκίνησης είναι άκυρος",
      "SupplierAlreadyExists": "Ο προμηθευτής υπάρχει ήδη",
      "SupplierCustomerInvalid": "Ο προμηθευτής θέσης είναι άκυρος",
      "LocationAlreadyExists": "Η τοποθεσία υπάρχει ήδη",
      "JavaApiInternalServerError": "Προέκυψε σφάλμα",
      "NewsNotFound": "Το μήνυμα δεν βρέθηκε",
      "OrderMessageTooLong": "Το μήνυμα της παραγγελίας υπερβαίνει το μέγιστο μήκος",
      "EmailInvalid": "Το email είναι άκυρο",
      "TokenInvalidAlreadyUsed": "Ο κωδικός που καταχωρήθηκε έχει ήδη χρησιμοποιηθεί",
      "SupplierBlocked": "Ο προμηθευτής είναι μπλοκαρισμένος",
      "PromotionExpired": "Διαφημιστικά είδη που έχουν λήξει"
    },
    "scannedProductNotAvailable": "Το προϊόν που σαρώθηκε δεν είναι διαθέσιμο στον κατάλογο του προμηθευτή σας, επομένως δεν μπορεί να προστεθεί στη λίστα του σαρωτή.",
    "scannerNotAvailable": "Δεν υπάρχει σαρωτής συνδεδεμένος στη συσκευή σας. Παρακαλούμε συνδεθείτε σε έναν σαρωτή ή ελέγξτε την υπάρχουσα σύνδεσή σας"
  },
  "error.": "Παρουσιάστηκε σφάλμα",
  "target": {
    "username": "Όνομα χρήστη",
    "user": "Χρήστης",
    "userAndPw": "@:target.username και @:input.password",
    "setting": "Ρύθμιση | Ρυθμίσεις",
    "profile": "Προφίλ",
    "location": "Τοποθεσία",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Προϊόν | Προϊόντα",
    "request": "Αίτημα",
    "list": "Λίστα",
    "required": "Υποχρεωτικό πεδίο",
    "field": "Πεδίο | Πεδία",
    "deliverer": "Προμηθευτής | Προμηθευτές",
    "tag": "Κατηγορία | Κατηγορίες",
    "password": "Κωδικός πρόσβασης",
    "permission": "Εξουσιοδότηση | Δικαιώματα"
  },
  "messages": {
    "orderFrom": "Παραγγελία από",
    "mobileWeb": "Παρατηρήσαμε ότι προσπαθείτε να ανοίξετε τη διαδικτυακή έκδοση του Octopus Order από κινητή συσκευή. Για καλύτερη εμπειρία χρήσης, σας συνιστούμε να κατεβάσετε την εφαρμογή για κινητά από το κατάστημα εφαρμογών σας σε κινητές συσκευές και να τη χρησιμοποιήσετε αντί για την έκδοση web.",
    "mobileWeb2": "Οι ακόλουθοι σύνδεσμοι θα σας μεταφέρουν στην εφαρμογή Octopus Order για κινητά:",
    "setting": {
      "location": "Επεξεργαστείτε την τοποθεσία σας",
      "profile": "Επεξεργαστείτε το προφίλ σας",
      "delivererAssign": "Αναθέστε έναν προμηθευτή στην τοποθεσία σας",
      "delivererSelect": "Επιλογή προμηθευτή",
      "inputCustomerNr": "Εισάγετε τον αριθμό πελάτη",
      "changeLocation": "Αλλαγή τοποθεσίας",
      "welcome1": "Γεια σας {name}",
      "welcome2": "Εδώ μπορείτε να επιλέξετε",
      "welcome3": "ποια αναπαράσταση προτιμάτε"
    },
    "emptyCart": "Λυπούμαστε, το καλάθι αγορών σας είναι άδειο.",
    "emptySuggestion": "Λυπούμαστε, δεν έχουμε προτάσεις προϊόντων για εσάς αυτή τη στιγμή.",
    "card": {
      "forwardPoints": "Κάντε κλικ εδώ για να μεταφερθείτε στο @:object.pointSystem",
      "points": "Σημεία Octopus",
      "shop": "Στο κατάστημα Octopus",
      "currentPromotion": "Τρέχουσες δράσεις",
      "createLocationExplanation": "Μια τοποθεσία μπορεί να είναι μπαρ, εστιατόριο, ξενοδοχείο, γραφείο ή παρόμοια επιχείρηση.",
      "productSuggestion": "Νέα και προτάσεις προϊόντων"
    },
    "noPromotion": "Λυπούμαστε, δεν έχουμε καμία προσφορά για εσάς αυτή τη στιγμή.",
    "promotion": {
      "order": "Παραγγελίες στο",
      "octopus": "Προωθητικές ενέργειες Octopus",
      "deliverer": "Προωθητικές ενέργειες από τους προμηθευτές σας",
      "articles": "Αυτά τα άρθρα έχουν ειδική τιμή αυτή τη στιγμή"
    },
    "home": {
      "createLocation": "Νέα @:messages.location.create",
      "welcome1": "Hello {name}",
      "welcome2": "ποια τοποθεσία θα θέλατε;",
      "image1": "Αναμειγνύεται, δοκιμάζεται, παραγγέλνεται!",
      "image2": "Ασφαλής, ψηφιακή, παραγγελία!",
      "image3": "Απλή, γρήγορη, παράδοση!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Όλα τα διαθέσιμα άρθρα",
        "delivererCatalog": "Ποικιλία του προμηθευτή",
        "createProduct": "Προσθήκη προϊόντος",
        "createdCustomProduct": "Το προϊόν έχει προστεθεί στη λίστα.",
        "noReducedSupplier": "Επί του παρόντος, κανένας από τους προμηθευτές σας δεν προσφέρει προσφορές."
      },
      "home": {
        "orders": "Οι τελευταίες σας παραγγελίες",
        "favouriteList": "Οι τελευταίες σας παραγγελίες",
        "news": "Νέα του χταποδιού"
      },
      "list": {
        "allLists": "Όλες οι λίστες αυτής της τοποθεσίας",
        "createList": "Νέα @:titleRoute.addList",
        "noSupplier": "Δεν έχετε προσθέσει ακόμη έναν προμηθευτή στην τοποθεσία σας. Παρακαλούμε προσθέστε έναν προμηθευτή μέσω των ρυθμίσεων."
      },
      "message": {
        "available": "Διαθέσιμα νέα"
      },
      "setting": {
        "order": "Τα πάντα για τις παραγγελίες σας με μια ματιά",
        "team": "Επισκόπηση και διαχείριση της ομάδας σας",
        "deliverer": "Εδώ μπορείτε να δείτε τους προμηθευτές σας",
        "notification": "Διαχειριστείτε τις ειδοποιήσεις σας εδώ",
        "display": "Επιλέξτε μεταξύ σκοτεινής ή φωτεινής λειτουργίας",
        "statistic": "Εδώ μπορείτε να δείτε τις αξιολογήσεις σας",
        "imprint": "Πληροφορίες και νομικά",
        "support": "Επικοινωνία Octopus Order",
        "orderNotificationTimer": "Ρυθμίστε τον συναγερμό παραγγελίας σας",
        "intro": "Ανακαλύψτε όλα τα χαρακτηριστικά της εφαρμογής"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Στείλτε μήνυμα",
      "create": "Προσθήκη τοποθεσίας",
      "requestSent": "Το αίτημά σας προς τον προμηθευτή {deliverer} επανεξετάζεται. Ένας εκπρόσωπος θα επικοινωνήσει μαζί σας τις επόμενες ημέρες.",
      "assignDeliverer": "Αναθέστε έναν προμηθευτή στην τοποθεσία σας",
      "welcome1": "Γεια σας {name}",
      "intro": "Σε 4 σύντομα βήματα ολοκληρώνουμε μαζί το προφίλ σας"
    },
    "noOrders": "Δεν έχετε κάνει καμία παραγγελία ακόμα.",
    "noOrdersFilter": "Δεν έχετε τοποθετήσει καμία παραγγελία σε αυτό το χρονικό διάστημα.",
    "noLists": "Δεν έχετε δημιουργήσει καμία λίστα ακόμα.",
    "noNotifications": "Δεν έχετε λάβει καμία ειδοποίηση ακόμα.",
    "noNews": "Λυπούμαστε, προς το παρόν δεν υπάρχουν διαθέσιμα νέα για το Octopus.",
    "order": {
      "deliveryType": "Επιλέξτε μέθοδο παράδοσης",
      "deliveryTime": "Επιλέξτε ημέρα παράδοσης",
      "pickupTime": "Επιλέξτε ώρα παραλαβής",
      "pickup": "Παραλαβή",
      "delivery": "Παράδοση",
      "overview": "Επισκόπηση παραγγελιών",
      "choosePayment": "Επιλογή τρόπου πληρωμής",
      "redirectPayment": "Στο επόμενο βήμα θα ανακατευθυνθείτε στο {target}.",
      "rememberPayment": "Χρησιμοποιήστε τη μέθοδο πληρωμής για μελλοντικές παραγγελίες.",
      "voucher": "Κουπόνι | Κουπόνια",
      "redeemVoucher": "@:messages.order.voucher redeem",
      "voucherCode": "Εισάγετε τον κωδικό κουπονιού",
      "currentOrders": "Οι παραγγελίες μου",
      "orderProducts": "Η παραγγελία σας @:object.article",
      "otherProducts": "Άλλα συχνά παραγγελθέντα άρθρα",
      "sent": "Η παραγγελία σας διαβιβάστηκε επιτυχώς στον {στόχο}.",
      "locationIssue": "Αγνοείται η τοποθεσία παραλαβής. Παρακαλούμε εισάγετε μια τοποθεσία παραλαβής."
    },
    "deliverer": {
      "allDeliverers": "Όλοι @:object.deliverer από {location}",
      "addDeliverer": "Προσθέστε ένα @:object.deliverer",
      "noEmail": "Παρακαλώ προσθέστε μια διεύθυνση ηλεκτρονικού ταχυδρομείου στον παραλήπτη πριν μπορέσετε να παραγγείλετε"
    },
    "team": {
      "invite": {
        "welcome1": "@:messages.home.welcome1",
        "welcome2": "Προσκαλέστε άλλους υπαλλήλους ή συνεργάτες στην εφαρμογή...",
        "copy": "Ή απλά αντιγράψτε τον κώδικα και μοιραστείτε τον:",
        "messenger": "Προσκαλέστε απευθείας μέσω του messenger της επιλογής σας:",
        "mail": "Με διεύθυνση ηλεκτρονικού ταχυδρομείου",
        "joinTeam": "Γίνετε μέλος της ομάδας μας",
        "joinTeam2": "Έχετε προσκληθεί στην τοποθεσία {location} στην εφαρμογή Octopus Order App!\n\nΜε αυτόν τον σύνδεσμο μπορείτε να ενταχθείτε απευθείας στην ομάδα σας.\n\n{inviteLink}\n\nΑν αυτό δεν λειτουργεί, μπορείτε να μπείτε στην εφαρμογή με τον κωδικό\n\n{link}\n\nγια να ενταχθείτε στη νέα σας ομάδα.\n\nΓια Android: {appLinkAndroid}\n\nΓια IOS: {appLinkIOS}",
        "shareHint": "Για λόγους ασφαλείας, ο παραγόμενος/αποστελλόμενος κωδικός μπορεί να προσκαλέσει μόνο βασικούς χρήστες. Για πρόσκληση με τα επιλεγμένα δικαιώματα, χρησιμοποιήστε την πρόσκληση μέσω e-mail."
      },
      "management": {
        "members": "Μέλη της ομάδας από την {location}",
        "inviteMember": "Πρόσκληση μελών της ομάδας",
        "addDevice": "Προσθήκη συσκευής",
        "permissionExplanation": "Επισκόπηση των δικαιωμάτων των ρόλων μας:"
      }
    },
    "missingPermission": "Έλλειψη δικαιώματος: {permission}",
    "missingCartOrderPermission": "Τα δικαιώματά σας στην εφαρμογή δεν επαρκούν. Παρακαλούμε επικοινωνήστε με τον ιδιοκτήτη της τοποθεσίας σας για να ολοκληρώσετε μια παραγγελία.",
    "permission": {
      "all": "Όλα τα δικαιώματα",
      "locationOrderHistoryRead": "Ανάγνωση ιστορικού παραγγελιών",
      "locationListRead": "Προβολή λιστών",
      "locationListItemRead": "Προβολή λίστας προϊόντων",
      "locationListItemCreate": "Δημιουργία προϊόντων λίστας",
      "locationListItemUpdate": "Επεξεργασία προϊόντων λίστας",
      "locationListItemDelete": "Διαγραφή προϊόντων λίστας",
      "locationListCreate": "Δημιουργία καταλόγων",
      "locationListUpdate": "Επεξεργασία λιστών",
      "locationListDelete": "Διαγραφή λιστών",
      "locationCartRead": "Προβολή καλαθιού αγορών",
      "locationCartAdd": "Συμπλήρωση καλαθιού αγορών",
      "locationCartUpdate": "Επεξεργασία προϊόντων καλαθιού αγορών",
      "locationCartDelete": "Διαγραφή προϊόντων καλαθιού αγορών",
      "locationOrderCreate": "Δημιουργία παραγγελίας",
      "locationOrderRequest": "Εκτέλεση αίτησης παραγγελίας",
      "locationRead": "Προβολή τοποθεσίας",
      "locationCreate": "Δημιουργία τοποθεσίας",
      "locationUpdate": "Επεξεργασία τοποθεσίας",
      "locationDelete": "Διαγραφή τοποθεσίας",
      "locationTeamRead": "Προβολή ομάδας",
      "locationTeamMemberAdd": "Προσθήκη μέλους ομάδας",
      "locationTeamMemberDelete": "Διαγραφή μέλους ομάδας",
      "locationTeamMemberRoleUpdate": "Επεξεργασία ρόλων μέλους ομάδας",
      "locationSupplierRead": "Προβολή προμηθευτών",
      "locationSupplierCreate": "Προσθήκη προμηθευτών",
      "meRead": "Ανάγνωση δεδομένων χρήστη",
      "meUpdate": "Επεξεργασία δεδομένων χρήστη",
      "meDelete": "Διαγραφή δικού του χρήστη",
      "locationListReminderCreate": "Δημιουργία συναγερμού παραγγελίας",
      "locationListReminderDelete": "Διαγραφή συναγερμού παραγγελίας",
      "locationListReminderRead": "Προβολή συναγερμού παραγγελίας",
      "locationListReminderUpdate": "Επεξεργασία συναγερμού παραγγελίας",
      "locationContactSupplier": "Επικοινωνία με τον προμηθευτή"
    },
    "noListEntries": "Δεν υπάρχουν προς το παρόν στοιχεία σε αυτή τη λίστα",
    "noSearchResults": "Δεν βρέθηκαν άρθρα για το φίλτρο σας",
    "noEntries": "Δεν υπάρχουν διαθέσιμα αντικείμενα",
    "noMail": "Δεν ελήφθη αλληλογραφία",
    "login": {
      "emailSent": "Μόλις σας στείλαμε ένα email",
      "setPassword": "Μπορείτε να ορίσετε νέο κωδικό πρόσβασης μέσω του συνδέσμου",
      "resetPassword": "Εισάγετε τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας και λάβετε έναν νέο κωδικό πρόσβασης"
    },
    "start": {
      "notNew": "Είστε ήδη πελάτης",
      "new": "Πρώτη φορά εδώ"
    },
    "cart": {
      "amount": "{amount} Θέσεις στοιχείων",
      "selectionFrom": "Επιλογή στο {deliverer}",
      "fromList": "Από τις λίστες σας",
      "noList": "Χωρίς λίστα",
      "lastOrder": "Από την τελευταία σας παραγγελία",
      "amountItems": "{amount} Ενιαίο άρθρο",
      "upgradeToPromotion": "Σχεδόν φτάσαμε! Απλά {amount} Κομμάτια μέχρι το {shortTitle} Δράση 🏷️ → παραγγείλετε τώρα",
      "convertToPromotion": "Δράση εξασφαλισμένη 🏷️ → ενεργοποιήστε τώρα"
    },
    "register": {
      "intro": "Για να δημιουργήσουμε το προφίλ σας χρειαζόμαστε κάποιες πληροφορίες",
      "thank": "Σας ευχαριστώ {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Παρακαλώ επιβεβαιώστε το λογαριασμό σας μέσω του συνδέσμου",
      "validateEmail": "@:{'messages.register.validate'} που αποστέλλεται στη διεύθυνση ηλεκτρονικού ταχυδρομείου σας πριν μπορέσετε να παραγγείλετε",
      "noCode": "Δεν έχω κωδικό πρόσκλησης",
      "code": "Έχω λάβει έναν κωδικό πρόσκλησης",
      "skipEmail": "Δυστυχώς, δεν μπορέσαμε να βρούμε τη διεύθυνση ηλεκτρονικού ταχυδρομείου που δηλώσατε. Παρακαλούμε επιβεβαιώστε ξανά τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας."
    },
    "didYouMean": "Ψάχνετε για {target} κατά τύχη;",
    "didYouCheck": "Έχετε αναζητήσει όλους τους προμηθευτές στην προηγούμενη προβολή;",
    "agbRequired": "Πρέπει να συμφωνήσετε με την πολιτική απορρήτου.",
    "list": {
      "repeatEach1": "Υπενθύμιση",
      "repeatEach2": "Όλα",
      "noTags": "Δεν υπάρχουν διαθέσιμες κατηγορίες φίλτρων. Προσθέστε κατηγορίες στα προϊόντα της λίστας σας.",
      "overrideCartList": "Ο κατάλογος βρίσκεται ήδη στο καλάθι αγορών. Θέλετε να αντικαταστήσετε το καλάθι αγορών σας;",
      "overrideProductList": "Αυτό το προϊόν βρίσκεται ήδη στο καλάθι αγορών σας. Θέλετε να αντικαταστήσετε το καλάθι αγορών σας;",
      "noReminder": "Δεν έχουν δημιουργηθεί ακόμη συναγερμοί παραγγελίας για αυτή τη λίστα.",
      "amountReset": "Οι ποσότητες των προϊόντων έχουν μηδενιστεί.",
      "resetCheck": "Είστε σίγουρος ότι θέλετε να επαναφέρετε όλες τις ποσότητες σε αυτόν τον κατάλογο στο 0"
    },
    "pressEnter": "Επιβεβαιώστε στο πληκτρολόγιο για να προσθέσετε",
    "changedEmail": "Μόλις σας στείλαμε ένα email στη νέα διεύθυνση. Για να εφαρμόσετε την αλλαγή, κάντε κλικ στον σύνδεσμο που σας εστάλη.",
    "updateLoading": "Η ενημέρωση εγκαθίσταται",
    "intro": {
      "home": {
        "msg1": "Κάντε κλικ στην επικεφαλίδα για να επιστρέψετε στην επισκόπηση της τοποθεσίας σας και στο καλάθι αγορών.",
        "title1": "Επισκεφθείτε τις τοποθεσίες σας και το καλάθι αγορών",
        "msg2": "Οι πιο πρόσφατες παραγγελίες σας και οι λίστες με τις συχνές παραγγελίες είναι προσβάσιμες απευθείας μέσω του ταμπλό.",
        "title2": "Επισκόπηση των δραστηριοτήτων σας",
        "msg3": "Χρησιμοποιήστε τη γραμμή μενού για να φτάσετε στον προορισμό σας με ένα μόνο κλικ.",
        "title3": "Πλοήγηση προσβάσιμη παντού"
      },
      "list": {
        "title1": "Η παραγγελία ξεκινά από εδώ",
        "msg1": "Μπορείτε να έχετε πρόσβαση στις λίστες σας και στον κατάλογο μέσω της κεφαλίδας. Εδώ μπορείτε να αναζητήσετε τα άρθρα των προμηθευτών σας.",
        "title2": "Οι προμηθευτές σας",
        "msg2": "Εδώ μπορείτε να δείτε και να επεξεργαστείτε τους καταλόγους παραγγελιών των προμηθευτών σας ή να δημιουργήσετε μόνοι σας νέους καταλόγους.",
        "title3": "Ταξινόμηση και διαγραφή",
        "msg3": "Πατήστε την εικόνα του προϊόντος για να επιλέξετε ένα ή περισσότερα είδη, να τα μετακινήσετε με drag & drop ή να τα διαγράψετε πατώντας το εικονίδιο του κάδου απορριμμάτων.",
        "title4": "Εύκολη προσαρμογή της λίστας",
        "msg4": "Η ποσότητα ενός προϊόντος μπορεί να αλλάξει με τα πλήκτρα συν και μείον. Σύρετε προς τα δεξιά για να αφαιρέσετε το προϊόν από τη λίστα.",
        "title5": "Γρήγορη εύρεση προϊόντων",
        "msg5": "Στον κατάλογο μπορείτε να δείτε και να αναζητήσετε τα μεμονωμένα είδη των προμηθευτών σας και να τα φιλτράρετε ανά κατηγορία."
      },
      "promotion": {
        "title1": "Προωθητικές ενέργειες και προτάσεις",
        "msg1": "Εδώ μπορείτε να δείτε τρέχουσες προσφορές, προτάσεις προϊόντων ή νέα από τους προμηθευτές σας ή από το Octopus Order.",
        "title2": "Προσφορές προώθησης από τους προμηθευτές σας",
        "msg2": "Εδώ μπορείτε να δείτε άρθρα από τους προμηθευτές σας για τα οποία υπάρχουν σήμερα ειδικές προσφορές.",
        "title3": "Τρέχουσες προτάσεις και νέα",
        "msg3": "Με τις προτάσεις προϊόντων ενημερώνεστε για τις τελευταίες τάσεις στον κλάδο των ποτών. Στην ενότητα με τα νέα μπορείτε να ενημερωθείτε για όλα τα τελευταία νέα σχετικά με το Octopus."
      },
      "setting": {
        "msg1": "Εδώ μπορείτε να διαχειριστείτε τους προμηθευτές και τις τοποθεσίες σας, να κάνετε ρυθμίσεις, να δείτε τις παραγγελίες ή να επικοινωνήσετε με την υποστήριξη.",
        "title1": "Ρυθμίσεις εφαρμογής",
        "msg2": "Εδώ μπορείτε να ρυθμίσετε συναγερμούς για να σας υπενθυμίζουν τακτικά να παραγγείλετε τη λίστα σας.",
        "title2": "Μην ξεχάσετε ποτέ ξανά μια παραγγελία",
        "msg3": "Εδώ μπορείτε να διαχειριστείτε την ομάδα σας και να προσκαλέσετε άλλα μέλη της ομάδας στο Octopus Order.",
        "title3": "Η δική σας ομάδα",
        "msg4": "Εδώ έχετε μια επισκόπηση όλων των προμηθευτών σας και μπορείτε να τους επεξεργαστείτε ή να τους αφαιρέσετε καθώς και να προσθέσετε νέους προμηθευτές.",
        "title4": "Επισκόπηση προμηθευτών"
      }
    },
    "ordering": "Η παραγγελία εκτελείται",
    "noConnection1": "Δεν υπάρχει σύνδεση με τον διακομιστή",
    "noConnection2": "Ελέγξτε τη σύνδεσή σας στο διαδίκτυο",
    "switchLocation": "Η ειδοποίηση ανήκει σε άλλη τοποθεσία. Θέλετε να αλλάξετε τοποθεσία;",
    "containsExpiredPromotion": "Υπάρχει ένα ληγμένο διαφημιστικό προϊόν στο καλάθι αγορών σας. Παρακαλούμε αφαιρέστε το για να συνεχίσετε την παραγγελία σας.",
    "addProductsViaScanner": "Προσθήκη προϊόντων μέσω σαρωτή",
    "scanDesiredProducts": "Σαρώστε τα προϊόντα που επιθυμείτε",
    "scanToAddMoreProducts": "Σαρώστε για να προσθέσετε περισσότερα προϊόντα",
    "updateScanItems": "Θα θέλατε να προσθέσετε τα σαρωμένα προϊόντα σας στη λίστα σας Ο αριθμός των αντικειμένων στη λίστα θα αντικατασταθεί.",
    "addScanItems": "Θα θέλατε να προσθέσετε τα σαρωμένα προϊόντα σας στο καλάθι αγορών",
    "holidayDeliveryTitle": "Η επιλεγμένη ημέρα παράδοσης είναι αργία!",
    "holidayDelivery": "Παρακαλούμε ρωτήστε τον προμηθευτή σας για την ακριβή ημερομηνία παράδοσης.",
    "longOrder": "Η παραγγελία σας είναι περισσότερο από επτά ημέρες στο μέλλον. Θέλετε πραγματικά να παραγγείλετε την {date}",
    "cartDataMissing": "Δεδομένα παραγγελίας λανθασμένα",
    "newBinaryVersion": "Μια νέα έκδοση είναι διαθέσιμη και περιέχει σημαντικές αλλαγές. Παρακαλούμε ενημερώστε την έκδοσή σας.",
    "deliveryDayWarningTitle": "Η επιλεγμένη ημερομηνία δεν είναι κανονική ημέρα παράδοσης!",
    "deliveryDayWarning": "Παρακαλείστε να διευκρινίσετε εκ των προτέρων τις εξαιρετικές περιπτώσεις με τον προμηθευτή.",
    "holidayPickupTitle": "Η επιλεγμένη ημέρα συλλογής είναι αργία!",
    "holidayPickup": "Παρακαλούμε ρωτήστε τον προμηθευτή σας για την ακριβή ημερομηνία συλλογής.",
    "modal": {
      "updateLocationTypeTitle": "Η επιλογή σας, το πλεονέκτημά σας",
      "updateLocationTypeDescription": "Όταν επιλέγετε την επιχείρηση τροφοδοσίας σας, προσαρμόζουμε το περιεχόμενο και τις προωθητικές ενέργειες για εσάς. Μπορείτε να αλλάξετε αυτή τη ρύθμιση ανά πάσα στιγμή.",
      "updateLocationTypeHint": "Η επιλογή χρησιμοποιείται μόνο εντός της εφαρμογής και μπορεί να προσαρμοστεί ανά πάσα στιγμή."
    },
    "currentLocation": "Αυτή τη στιγμή βρίσκεστε στην τοποθεσία"
  },
  "object": {
    "order": "Παραγγελία | Παραγγελίες",
    "article": "Θέσεις αντικειμένων",
    "promotion": "Δράση | Δράσεις",
    "location": "Τοποθεσία",
    "cart": "Καλάθι αγορών",
    "list": "Λίστα | Λίστες",
    "filter": "Φίλτρο",
    "message": "Νέα | Νέα",
    "catalog": "Κατάλογος",
    "notification": "Ειδοποιήσεις | Ειδοποιήσεις",
    "notificationOption": "@:object.notification{'soptions'}",
    "setting": "Ρυθμίσεις",
    "intro": "Apptour",
    "home": "Αρχική σελίδα",
    "dark": "Σκοτάδι",
    "light": "Light",
    "zip": "POSTCODE",
    "city": "Πόλη",
    "street": "Οδός",
    "lastname": "Όνομα",
    "firstname": "Όνομα",
    "address": "Διεύθυνση",
    "zipCity": "@object:zip, @object:city",
    "profile": "Προφίλ",
    "pointSystem": "Σύστημα σημείων",
    "amount": "Ποσότητα",
    "price": "Τιμή μονάδας",
    "total": "Συνολική τιμή",
    "notAvailable": "Πληροφορίες για την τιμή δεν είναι διαθέσιμες",
    "sort": "Ταξινόμηση",
    "alphabetic": "Αλφαβητική σειρά",
    "filterCategory": "@:object.filter{'category'}",
    "priceRange": "Εύρος τιμών",
    "team": "Ομάδα",
    "deliverer": "Προμηθευτής | Προμηθευτές",
    "display": "Επιλογές εμφάνισης",
    "statistic": "Στατιστικά στοιχεία",
    "imprint": "Αποτύπωμα",
    "law": "Νομικά",
    "support": "Υποστήριξη παραγγελιών Octopus",
    "filterOption": {
      "spirits": "Αλκοόλ",
      "nonAlcoholic": "Μη αλκοολούχα ποτά",
      "beer": "Μπύρα",
      "gastro": "Γαστρονομικές ανάγκες",
      "wine": "Κρασί",
      "food": "Τρόφιμα",
      "nonFood": "Μη Τροφίμων",
      "other": "Άλλα"
    },
    "suggestion": "Προϊόν{πρόταση} | Προϊόν{πρόταση}",
    "news": "Νέα",
    "days": "Ημέρες | Ημέρα",
    "hours": "Ώρες | Ώρα",
    "minutes": "Λεπτά | Λεπτό",
    "validFor": "Ισχύει για {value}",
    "validUntil": "Ισχύει μέχρι",
    "expired": "Έληξε",
    "totalPosition": "Συνολική θέση",
    "totalOrder": "Συνολική αξία παραγγελίας"
  },
  "enumT": {
    "pinned": "Pinned",
    "new": "Νέα",
    "restocked": "Διαθέσιμο ξανά",
    "reduced": "Στην προσφορά",
    "notInStock": "Με χρόνο παράδοσης",
    "promotion": "Διαφημιστικά αντικείμενα",
    "issueType": {
      "bug": "Bug",
      "feature": "Χαρακτηριστικό γνώρισμα"
    },
    "contactWay": {
      "none": "Μην επικοινωνείτε με",
      "email": "Email",
      "phone": "Τηλέφωνο",
      "emailOrPhone": "Email ή τηλέφωνο"
    },
    "sortDirection": {
      "asc": "Αύξουσα αλφαβητική σειρά",
      "desc": "Κατιούσα αλφαβητική σειρά",
      "catFilter": "Με δική σας κατηγορία",
      "catSupplier": "Ανά κατηγορία προμηθευτή",
      "manually": "Χειροκίνητη διαλογή"
    },
    "weekday": {
      "mon": "Δευτέρα",
      "tue": "Τρίτη",
      "wed": "Τετάρτη",
      "thu": "Πέμπτη",
      "fri": "Παρασκευή",
      "sat": "Σάββατο",
      "sun": "Κυριακή"
    },
    "repeatCycle": {
      "once": "μοναδικό",
      "week": "εβδομαδιαία",
      "month": "μηνιαία",
      "appendix": {
        "week": "εβδομάδα(ες)",
        "month": "μήνας(ες)"
      }
    },
    "month": {
      "january": "Ιανουάριος",
      "february": "Φεβρουάριος",
      "march": "Μάρτιος",
      "april": "Απρίλιος",
      "may": "Μάιος",
      "june": "Ιούνιος",
      "july": "Ιούλιος",
      "august": "Αύγουστος",
      "september": "Σεπτέμβριος",
      "october": "Οκτώβριος",
      "november": "Νοέμβριος",
      "december": "Δεκέμβριος"
    }
  },
  "modal": {
    "selection": "Επιλογές",
    "addList": "Προσθήκη στη λίστα",
    "addCart": "Προσθήκη στο καλάθι αγορών",
    "openCatalog": "Άνοιγμα στον κατάλογο"
  },
  "success": {
    "addReminder": "Η παραγγελία ξυπνητήρι προστέθηκε",
    "editReminder": "Η παραγγελία συναγερμού αποθηκεύτηκε",
    "deleteReminder": "Η παραγγελία συναγερμού διαγράφηκε",
    "addCart": "Το προϊόν έχει προστεθεί στο καλάθι αγορών. | Το προϊόν προστέθηκε στο καλάθι αγορών",
    "addPromoPackage": "Το πακέτο προώθησης προστέθηκε στο καλάθι αγορών.",
    "addCartNumber": "{target} Μεμονωμένα είδη από {target2} θέσεις ειδών προστέθηκαν στο καλάθι αγορών",
    "addList": "Το προϊόν έχει προστεθεί στη λίστα. | Τα προϊόντα έχουν προστεθεί στη λίστα.",
    "order": "Η λίστα έχει παραγγελθεί.",
    "save": "{target} αποθηκεύτηκε επιτυχώς. | {target} έχουν αποθηκευτεί επιτυχώς.",
    "resendMail": "Το email στάλθηκε εκ νέου.",
    "copyLink": "Ο σύνδεσμος αντιγράφηκε",
    "sendLink": "Ο σύνδεσμος εστάλη.",
    "removeProduct": "Το προϊόν έχει αφαιρεθεί από το καλάθι αγορών. | Το προϊόν έχει αφαιρεθεί από το καλάθι αγορών.",
    "orderFinish": "Η παραγγελία δημιουργήθηκε.",
    "delete": "{target} has been deleted.",
    "deleteUser": "Ο χρήστης έχει διαγραφεί",
    "deleteMulti": "{amount} {target} έχουν διαγραφεί.",
    "send": "{target} has been sent.",
    "create": "{target} was created.",
    "edit": "{target} has been successfully edited.",
    "add": "{target} έχει προστεθεί.",
    "deleteTeam": "Ο χρήστης έχει αφαιρεθεί από την ομάδα.",
    "setRole": "Ο ρόλος του χρήστη ορίστηκε επιτυχώς",
    "joinLocation": "Η τοποθεσία προστέθηκε επιτυχώς",
    "sendInvite": "Το μήνυμα πρόσκλησης έχει σταλεί.",
    "sendTicket": "Λάβαμε τα σχόλιά σας. Σας ευχαριστούμε πολύ.",
    "aiCall": "Το Octobot θα σας καλέσει σύντομα."
  },
  "success.": "Επιτυχής καμπάνια",
  "alert": {
    "delete": {
      "account": "Θέλεις να διαγράψεις οριστικά τον λογαριασμό σου και όλες τις σχετικές τοποθεσίες;",
      "reminder": "Θέλετε πραγματικά να διαγράψετε αυτόν τον συναγερμό παραγγελίας;",
      "location": "Θέλετε πραγματικά να διαγράψετε αυτή την τοποθεσία;",
      "list": "Θέλετε πραγματικά να διαγράψετε τη λίστα \"{target}\"?",
      "noList": "Θέλετε να αφαιρέσετε όλα τα προϊόντα από το καλάθι αγορών σας",
      "cartSupplier": "Θέλετε να αδειάσετε το καλάθι αγορών σας στο \"{target}\"?",
      "cartProduct": "Θέλετε πραγματικά να διαγράψετε το προϊόν \"{target}\" από το καλάθι αγορών;",
      "cartList": "Θέλετε πραγματικά να διαγράψετε τη λίστα \"{target}\" και όλα τα σχετικά προϊόντα από το καλάθι αγορών;",
      "product": "Θέλετε πραγματικά να διαγράψετε το προϊόν \"{target}\" από τη λίστα; | Θέλετε πραγματικά να διαγράψετε τα επιλεγμένα προϊόντα από τη λίστα;",
      "supplier": "Θέλετε πραγματικά να διαγράψετε το {name} από τους προμηθευτές σας; Προσοχή: Η διαγραφή ενός προμηθευτή καταργεί επίσης όλες τις λίστες για αυτόν τον προμηθευτή.",
      "member": "Θέλετε πραγματικά να αφαιρέσετε τον {στόχο}\" από την ομάδα;",
      "tag": "Θέλετε πραγματικά να αφαιρέσετε το \"{target}\" από τις κατηγορίες σας;",
      "customSupplier": "Θέλετε πραγματικά να διαγράψετε αυτόν τον προμηθευτή;",
      "scanProduct": "Θέλετε πραγματικά να αφαιρέσετε το προϊόν \"{target}\" από τα σαρωμένα αντικείμενά σας"
    },
    "delivererSuccess": "Ο προμηθευτής προστέθηκε επιτυχώς",
    "delivererError": "Σφάλμα",
    "delivererSuccessMessage": "Προσθέσαμε {target} στην τοποθεσία σας.",
    "delivererErrorMessage": "Ο {target} δεν μπόρεσε να προστεθεί στη θέση σας. Παρακαλούμε ελέγξτε τα δεδομένα που καταχωρήσατε.",
    "selectList": "Επιλέξτε μια λίστα",
    "selectSupplier": "Επιλέξτε έναν προμηθευτή",
    "noList": "Δεν υπάρχει διαθέσιμη λίστα για αυτόν τον προμηθευτή.",
    "noSupplier": "Δεν υπάρχει διαθέσιμος προμηθευτής για αυτό το στοιχείο",
    "discardFormTitle": "Προσοχή!",
    "noInternet": "Δεν μπορούν να συγχρονιστούν όλα τα δεδομένα εκτός σύνδεσης. Παρακαλούμε ελέγξτε τη σύνδεσή σας στο διαδίκτυο.",
    "compatibilityMode": "Έχετε ενεργοποιήσει τη λειτουργία συμβατότητας. Όσο αυτή είναι ενεργή, μπορείτε να παραγγείλετε μόνο μέσω της διαδικτυακής πύλης. Η καθορισμένη ποσότητα βρίσκεται τώρα στο καλάθι αγορών. Αν θέλετε να παραγγείλετε μέσω της εφαρμογής, απενεργοποιήστε αυτή τη λειτουργία στις ρυθμίσεις της λίστας.",
    "discardForm": "Τα δεδομένα σας δεν θα αποθηκευτούν. Φεύγετε ούτως ή άλλως από τη σελίδα;",
    "syncing": "Οι λίστες συγχρονίζονται",
    "logout": "Θέλετε πραγματικά να διαγράψετε την εγγραφή σας;",
    "upgradeToPromotion": "Χρήση της προώθησης τώρα? Η ποσότητα προσαρμόζεται αυτόματα στην ελάχιστη ποσότητα ({target})",
    "convertToPromotion1": "Εφαρμόστε την ενέργεια?",
    "convertToPromotion2": "{target1} Διαφημιστικό αντικείμενο, {target2} κανονικό",
    "orderAmountOverLimit": "Το όριο έχει επιτευχθεί: {isAmount} Διαφημιστικό προϊόν στο καλάθι αγορών. Μέγιστη δυνατή τιμή +{availableAmount}",
    "scannerNotActivated": "Η λειτουργία σαρωτή δεν υποστηρίζεται προς το παρόν από τους προμηθευτές σας!",
    "scannerAvailableOnlyInApp": "Η λειτουργία σαρωτή είναι διαθέσιμη μόνο στην εφαρμογή!",
    "addLastOrderToCart": "Θέλεις να προσθέσεις ξανά στο καλάθι όλα τα προϊόντα και τις ποσότητες της τελευταίας σου παραγγελίας;"
  },
  "titleRoute": {
    "locationData": "Δημιουργία τοποθεσίας",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Επιλογή προμηθευτή",
    "locationAdd": "Προσθήκη τοποθεσίας",
    "locationJoin": "Τοποθεσία ένταξης",
    "addLocationDeliverer": "Προσθήκη προμηθευτή",
    "editLocationDeliverer": "Επεξεργασία προμηθευτή",
    "settingProfile": "Προφίλ",
    "settingLocation": "Επεξεργασία τοποθεσίας",
    "settingOrder": "Παραγγελία | Παραγγελίες",
    "settingOrderDetail": "Λεπτομέρειες παραγγελίας",
    "settingTeam": "Ομάδα",
    "settingTeamInvite": "Πρόσκληση ομάδας",
    "settingDeliverer": "Προμηθευτές",
    "settingDelivererSelect": "Επιλέξτε προμηθευτή",
    "settingNotification": "Ειδοποιήσεις",
    "settingDisplay": "Επιλογές εμφάνισης",
    "settingSupport": "Υποστήριξη",
    "settingLegal": "Νομικά",
    "cart": "Καλάθι αγορών",
    "orders": "Παραγγελίες",
    "filter": "Φίλτρο",
    "addList": "Δημιουργία λίστας",
    "editList": "Επεξεργασία λίστας",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Παραγγελία συναγερμού",
    "changePassword": "Αλλαγή κωδικού πρόσβασης",
    "addProduct": "Προσθήκη προϊόντος",
    "editProduct": "Επεξεργασία προϊόντος",
    "agb": "Πολιτική απορρήτου",
    "news": "Χταπόδι Νέα",
    "suggestion": "Πρόταση προϊόντος",
    "productDetails": "Λεπτομέρειες προϊόντος",
    "promotionDetails": "Λεπτομέρειες δράσης",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Δημιουργία ανατροφοδότησης",
    "scanner": "Σαρωτής",
    "skipEmail": "Επαλήθευση email",
    "deleteLocations": "Διαγραμμένες τοποθεσίες",
    "aiCall": "Παραγγελία AI"
  },
  "placeholder": {
    "search": "Αναζήτηση",
    "selectSize": "Επιλέξτε μέγεθος",
    "selectVariant": "Επιλέξτε παραλλαγή",
    "location": {
      "name": "Όνομα της τοποθεσίας σας",
      "type": "Τύπος τοποθεσίας",
      "zip": "Ταχυδρομικός κώδικας",
      "ownZip": "Ταχυδρομικός κώδικας της δικής σας τοποθεσίας",
      "city": "Πόλη",
      "street": "Οδός",
      "streetNumber": "No.",
      "phone": "Αριθμός τηλεφώνου",
      "internationalPhone": "Διεθνής αριθμός τηλεφώνου",
      "deliverer": "@:select object.deliverer",
      "customerNumber": "@:label.customerNumber enter"
    },
    "email": "Ηλεκτρονικό ταχυδρομείο",
    "newEmail": "Νέο email",
    "oldPassword": "Παλιό @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password επανάληψη",
    "sendMessageDeliverer": "Αποστολή μηνύματος στον {deliverer} ...",
    "inviteCode": "Εισάγετε τον κωδικό πρόσκλησης",
    "firstName": "@:label.firstName",
    "lastName": "@:label.lastName",
    "name": "Όνομα",
    "phone": "@:placeholder.location.phone",
    "street": "Street",
    "zip": "ΤΑΧΥΔΡΟΜΙΚΟΣ ΚΩΔΙΚΟΣ",
    "city": "Πόλη",
    "alphabetic": "Αλφαβητικό",
    "customerNumber": "Αριθμός πελάτη",
    "customerNumberPlus": "Αριθμός πελάτη/αριθμός καταστήματος πώλησης",
    "quickstart": "Κωδικός γρήγορης εκκίνησης",
    "paymentMethod": "Μέθοδος πληρωμής",
    "pickupMethod": "Τοποθεσία",
    "deliveryDate": "Ημερομηνία παράδοσης",
    "emailOrPhone": "@:placeholder.email",
    "code": "Κωδικός πρόσκλησης",
    "packaging": "Μέγεθος συσκευασίας",
    "searchOrAdd": "Αναζήτηση ή προσθήκη κατηγορίας",
    "tagName": "Όνομα κατηγορίας",
    "pickupLocation": "Παραλάβετε σε",
    "pickupDate": "Ώρα παραλαβής",
    "quantity": "Ποσότητα",
    "eancode": "Κωδικός EAN",
    "customSupplierType": "Τύπος προμηθευτή",
    "issueType": "Τύπος ανατροφοδότησης",
    "title": "Τίτλος",
    "bug": {
      "issue": "Ποιο είναι το πρόβλημα;",
      "place": "Πού παρουσιάζεται το πρόβλημα;",
      "expectation": "Ποια συμπεριφορά θα περιμένατε αντί της τρέχουσας συμπεριφοράς;",
      "steps": "Ποια βήματα έγιναν μέχρι να εμφανιστεί το σφάλμα; / Πώς μπορεί να αναπαραχθεί το σφάλμα;"
    },
    "feature": {
      "expectation": "Ποια πρόσθετη λειτουργία θα θέλατε να δείτε;",
      "place": "Πού λείπει η επιθυμητή λειτουργία;"
    },
    "select": "Επιλέξτε",
    "contactWay": "Πώς μπορούμε να επικοινωνήσουμε μαζί σας για ερωτήσεις και ενημερώσεις"
  },
  "option": {
    "industry": {
      "PRIVATE": "Ιδιωτικό",
      "GETRAENKEFACHGROSSHANDEL": "Χονδρικό εμπόριο ποτών",
      "LEBENSMITTEL_GROSSHANDEL": "Χονδρικό εμπόριο τροφίμων",
      "HANDELSWAREN_ALLGEMEIN": "Γενικά εμπορεύματα",
      "SONSTIGE": "Άλλα"
    },
    "customSupplierType": {
      "meat": "Προμηθευτής κρέατος",
      "vegetable": "Λαχανικά",
      "drinks": "Ποτά",
      "hygiene": "Άρθρα υγιεινής",
      "other": "Άλλα"
    }
  }
}

export default el;